<template>
    <div class="contact-page">
        <ScrollupSection />
        <div class="main">
          {{$route.params.type}}
            <HeaderSection />
            <InnerBreadcrumb :data="{ title: 'Contact Us', text: type}"/>
            <component :is="`contact-${type}`" />
            <!-- <MapSection /> -->
            <FooterSection />
        </div>
    </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import InnerBreadcrumb from '../components/InnerPages/InnerBreadcrumb/breadcrumbFour'
import ContactGeneral from '../components/ContactSection/contactGeneral'
import ContactSales from '../components/ContactSection/contactSales'
import ContactSupport from '../components/ContactSection/contactSupport'
// import MapSection from '../../MapSection/map'
import FooterSection from '../components/FooterSection/footerOne'

export default {
    name: 'Contact',
    props: ['type'],
    components: {
        ScrollupSection,
        HeaderSection,
        InnerBreadcrumb,
        ContactGeneral,
        ContactSales,
        ContactSupport,
        // MapSection,
        FooterSection
    }
}
</script>

<style>

</style>